import { Immutable } from "immer";
import React from "react";
import { Key } from "ts-key-enum";
import { t } from "ttag";

import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { updateFilterOptionValue } from "../reducers";
import { selectTextFilterQueries } from "../selectors";

import styles from "./index.module.scss";

type IProps = Immutable<{
    maxKeywordsNumber?: number;
}>;

export const TextFilterDisplay = (props: IProps): React.ReactNode => {
    const dispatch = useAppDispatch();

    const queries = useAppSelector(selectTextFilterQueries);

    const onRemoveClick = (value: string) => {
        dispatch(
            updateFilterOptionValue({
                facetType: "text",
                optionID: value,
                isSelected: false,
            }),
        );
    };

    const onRemoveKeyPress = (value: string, event: React.KeyboardEvent) => {
        if (event.key === Key.Enter) {
            dispatch(
                updateFilterOptionValue({
                    facetType: "text",
                    optionID: value,
                    isSelected: false,
                }),
            );
        }
    };

    if (!queries) {
        return null;
    }

    const textBoxes = queries.map((value, i) => {
        if (props.maxKeywordsNumber && props.maxKeywordsNumber - 1 < i) {
            return null;
        }
        return (
            <button
                type="button"
                key={i}
                className={styles.item}
                onKeyPress={(event) => onRemoveKeyPress(value, event)}
                onClick={() => onRemoveClick(value)}
            >
                <span className="customer-review__top-filters__item--text">
                    {value}
                </span>
                <span
                    className={styles.itemRemove}
                    title={t`Clear Search Text`}
                    aria-hidden="true"
                >
                    X
                </span>
                &nbsp;
                <span className="ada-screenreader-only">remove filter</span>
            </button>
        );
    });

    return <div>{textBoxes}</div>;
};
